<div class="popover top" [ngClass]="className">

  <button matIconButton type="button" class="close" (click)="popupCloseEvent.emit()" matTooltipPosition="above">
    <mat-icon>close</mat-icon>
  </button>

  <div class="arrow"></div>
  @if (title) {
  <div class="popover-header">
    <h4 class="popover-title">{{title | translate}}</h4>
  </div>
  }

  @if (bigTitle) {
  <div class="popover-big-header">
    <h4 class="popover-big-title text-uppercase" tt-popup-title>{{bigTitle | translate}}</h4>
  </div>
  }

  <!-- 
  if your popup uses complex material components in it's body, add a case here based on the PopupData.type 
  the default case adds PopupData.content as simple html to the template
  -->
  @switch (type) {
  @case ('ContextMenuPopup') {
  <div class="popover-content" [class.withElevationInfo]="showFeatureElevation">
    <div class="coordinate copy flex-container container-space-between" [title]="('share.copyLink' |translate)"
      (click)="emitEvent.emit(typeof content !== 'string' ? content.copyEvent : {});">
      <span [innerHTML]="typeof content !== 'string' ? content.coordinate : '- m'"></span>
      <button matIconButton><mat-icon>content_copy</mat-icon></button>
    </div>
  </div>
  }
  @default {
  <div class="popover-content" [class.withElevationInfo]="showFeatureElevation" [innerHTML]="content"></div>
  }
  }

  @if (showFeatureElevation) {
  <div class="popover-content elevationinfo">
      <span class="height-prefix">{{'elevation-profile.elevation' | translate}}</span>: <span class="">{{featureElevation() ?
      featureElevation() : '-'}} m </span>
  </div>
  }

  @if (emitCustomEvent) {
  <div class="popover-content" style="margin:0 12px">
    <button [matButton]="emitCustomEvent.buttonType || ''" type="button" [class]="emitCustomEvent.buttonClass ||''"
      style="width:100%;" (click)="emitEvent.emit(emitCustomEvent)">{{emitCustomEvent.label | translate}}</button>
  </div>
  }

  <div class="popover-footer">

   <!-- @if(type === 'geocoding' && title === 'geocoding.classification-street'){
    <div class="" style="margin-bottom: 9px;">
      <button matButton (click)="emitEvent.emit({'eventId': 'AddHouseNumber'})">
               <mat-icon fontSet="ngi" fontIcon="address"></mat-icon>
               {{'geocoding.add_housenumber'| translate}}
      </button>      
    </div>
    }
  -->

    @if (zoomToFeatureLink) {
    <div class="" style="text-align: center;">
      <a class="link"
        (click)="zoomToFeatureEvent.emit({coordinates:coordinates, zoomlevel:zoomlevel, zoomextent: zoomextent})">{{'popup.zoom_to_feature'
        | translate}}</a>
    </div>
    }
  </div>
</div>